import React, { useEffect } from 'react';

import Modal from 'components/utility/Modal/Modal';

import { ReactComponent as IconRemove } from 'icons/icon-remove.svg';

import { RemoveButton } from 'components/Selector/DSPSelector/SelectedDSPList/DSPItem/DSPItem';

import useMedia from 'hooks/useMedia';

import OnboardingForm from './components/OnboardingForm';
import Picture from './components/Picture';

import { ModalWrapper, RemoveButtonWrapper } from './styles';

interface IUserProfileOnboardingProps {
  setState: Function;
}

const UserProfileOnboarding: React.FC<IUserProfileOnboardingProps> = (
  props
) => {
  const { setState } = props;
  const isSmallScreen = useMedia('(max-width: 1100px)');

  useEffect(() => {
    setState({ showOnboarding: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const onCloseClick = (): void => setState({ showOnboarding: false });

  return !isSmallScreen ? (
    <div>
      <Modal borderRadius="9px" maxWidth="65em">
        <ModalWrapper>
          <OnboardingForm onCloseClick={onCloseClick} />
          <Picture />
          <RemoveButtonWrapper>
            <RemoveButton onClick={onCloseClick} isRemovable color="#001247">
              <IconRemove />
            </RemoveButton>
          </RemoveButtonWrapper>
        </ModalWrapper>
      </Modal>
    </div>
  ) : null;
};

export default UserProfileOnboarding;
